import React from 'react';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import PositioningSection from './components/PositioningSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import LookupSection from './components/LookupSection';
import LearnModeSection from './components/LearnModeSection';
import ScreenshotsSection from './components/ScreenshotsSection';
import BooksSection from './components/BooksSection';
import VocabularySection from './components/VocabularySection';
import DictionarySection from './components/DictionarySection';
import SpecSection from './components/SpecSection';
import ComparisonSection from './components/ComparisonSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import StatusSection from './components/StatusSection';
import SiteFooter from './components/SiteFooter';

function App() {
  return (
    <div id="top" className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:border focus:border-ink focus:bg-surface focus:px-4 focus:py-2"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-1">
        {/* Order follows a reader's questions: what is it, what does it do,
            how does the hard part work, what does it look like, where do books
            come from, what does it keep, and only then how it compares. */}
        <HeroSection />
        <PositioningSection />
        <FeaturesSection />
        <HowItWorksSection />
        <LookupSection />
        <LearnModeSection />
        <ScreenshotsSection />
        <BooksSection />
        <VocabularySection />
        <DictionarySection />
        <SpecSection />
        <ComparisonSection />
        <FaqSection />
        <AboutSection />
        <StatusSection />
      </main>
      <SiteFooter />
    </div>
  );
}

export default App;
